import { render, staticRenderFns } from "./goodsAmount.vue?vue&type=template&id=50fefe72&scoped=true&"
import script from "./goodsAmount.vue?vue&type=script&lang=js&"
export * from "./goodsAmount.vue?vue&type=script&lang=js&"
import style0 from "./goodsAmount.vue?vue&type=style&index=0&id=50fefe72&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50fefe72",
  null
  
)

export default component.exports